import { createSelector } from 'reselect';
import get from 'transmute/get';
const getInstallCodePaneStatus = get('installCodePaneStatus');
export const installCodePaneIsVisible = createSelector([getInstallCodePaneStatus], installCodePaneStatus => {
  return installCodePaneStatus.isVisible;
});